import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../api/admin";

const useClockLocationsQuery = () => {
  return useQuery({
    queryKey: ["clockLocations"],
    queryFn: () => adminApiClient.getClockLocations(),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export default useClockLocationsQuery;
